import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
} from '@angular/core';

import { AccountState, IAccount } from '@account-users/account/models';
import {
  FeatureToggleGroupNode,
  LicenseV2,
} from '@account-users/account/state/feature-toggles/models';

const FEATURES_GROUP_NAME = 'Features';

const LEFT_COLUMN_ORDER: ReadonlyArray<string> = [
  'Core',
  'Tools',
  'Marketing Automation',
  'Integrations',
  'Account settings',
  'Other',
  'Deprecated',
];

@Component({
  selector: 'app-feature-toggles',
  templateUrl: './feature-toggles.component.html',
  styleUrls: ['./feature-toggles.component.scss'],
})
export class FeatureTogglesComponent implements OnChanges {
  @HostBinding('class.disabled') @Input() disabled: boolean;
  @Input() groups: FeatureToggleGroupNode[] = [];
  @Input() account: IAccount;
  @Input() loading: boolean;
  @Input()
  @Output()
  addFeatureToggleLicense = new EventEmitter<{
    licenseCode: string;
    addLicense: boolean;
  }>();

  public AccountState = AccountState;
  public leftGroups: FeatureToggleGroupNode[] = [];
  public rightGroups: FeatureToggleGroupNode[] = [];

  public ngOnChanges(): void {
    const groups = this.groups ?? [];
    const rankOf = (name: string) => {
      const i = LEFT_COLUMN_ORDER.indexOf(name);
      return i === -1 ? LEFT_COLUMN_ORDER.length : i;
    };
    this.leftGroups = groups
      .filter((g) => g.name !== FEATURES_GROUP_NAME)
      .slice()
      .sort((a, b) => rankOf(a.name) - rankOf(b.name));
    this.rightGroups = groups.filter((g) => g.name === FEATURES_GROUP_NAME);
  }

  public trackByGroup(_: number, { name }: FeatureToggleGroupNode) {
    return name;
  }

  public trackByLicense(_: number, { code }: LicenseV2) {
    return code;
  }

  public isFailed(license: LicenseV2) {
    return license.state === AccountState.Failed;
  }

  public isDisabled(license: LicenseV2) {
    return (
      license.disabled ||
      license.state === AccountState.Pending ||
      license.state === AccountState.Failed ||
      this.account?.state === AccountState.Pending ||
      this.account?.state === AccountState.Failed ||
      this.account?.state === AccountState.SuspendPending ||
      this.account?.state === AccountState.Suspended ||
      this.account?.state === AccountState.SuspendFailed ||
      this.account?.state === AccountState.TerminatePending ||
      this.account?.state === AccountState.Terminated ||
      this.account?.state === AccountState.TerminateFailed ||
      this.account?.state === AccountState.DeleteScheduled ||
      this.account?.state === AccountState.DeletePending ||
      this.account?.state === AccountState.Deleted ||
      this.account?.state === AccountState.DeleteFailed ||
      this.account?.state === AccountState.ResumePending ||
      this.account?.state === AccountState.ResumeFailed
    );
  }
}
